<template>
  <v-row class="campos">
    <v-col cols="12" md="4">
      <ValidationProvider name="Escola" rules="required" v-slot="{ errors }">
        <e-label>Escola</e-label>
        <v-select
          v-model="escolaId"
          :items="escolas"
          item-text="descricao"
          item-value="id"
          :loading="carregando === 'escolas'"
          :error-messages="errors"
          no-data-text="Nenhuma escola disponível"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="4">
      <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
        <e-label>Turma</e-label>
        <v-select
          v-model="dados.turma_id"
          :items="turmas"
          item-text="descricao"
          item-value="id"
          :disabled="!escolaId"
          :loading="carregando === 'turmas'"
          :error-messages="errors"
          no-data-text="Nenhuma turma disponível para esta escola"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="4">
      <ValidationProvider name="Série" rules="required" v-slot="{ errors }">
        <e-label>Série</e-label>
        <v-select
          v-model="dados.serie_id"
          :items="series"
          item-text="descricao"
          item-value="id"
          :disabled="!dados.turma_id"
          :loading="carregando === 'series'"
          :error-messages="errors"
          no-data-text="Nenhuma série disponível para esta turma"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
  </v-row>
</template>

<script>
import { mensagemDeErro } from "./helpers";

/**
 * Escola, turma e série, nessa ordem. As turmas vêm do ano letivo do período vigente, e a série
 * é escolhida entre as da turma, porque a turma pode ser multissérie.
 */
export default {
  name: "EEscolhaDeTurma",
  props: {
    dados: { type: Object, required: true },
  },
  data() {
    return { escolaId: null, escolas: [], turmas: [], series: [], carregando: null };
  },
  watch: {
    escolaId(escolaId) {
      this.dados.turma_id = null;
      this.turmas = [];
      if (escolaId) this.carregar("turmas", () => this.servico().turmasDaEscola(escolaId));
    },
    "dados.turma_id": function aoTrocarTurma(turmaId) {
      this.dados.serie_id = null;
      this.series = [];
      if (turmaId) this.carregar("series", () => this.servico().seriesDaTurma(turmaId));
    },
    series(series) {
      if (series.length === 1) this.dados.serie_id = series[0].id;
    },
  },
  mounted() {
    this.carregar("escolas", () => this.servico().escolas());
  },
  methods: {
    servico() {
      return this.$services.preMatriculasService;
    },
    async carregar(lista, buscar) {
      this.carregando = lista;
      try {
        this[lista] = await buscar();
      } catch (error) {
        this.$emit("erro", mensagemDeErro(error));
      }
      this.carregando = null;
    },
  },
};
</script>
